import { render } from "./house-9.vue?vue&type=template&id=f4215c8a&scoped=true"
import script from "./house-9.vue?vue&type=script&lang=js"
export * from "./house-9.vue?vue&type=script&lang=js"

import "./house-9.vue?vue&type=style&index=0&id=f4215c8a&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4215c8a"]])

export default __exports__